import { render } from "./LoginPage.vue?vue&type=template&id=70ab6a7e&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=70ab6a7e&scoped=true&lang=css"

import exportComponent from "/Applications/Sites/mystudentvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ab6a7e"]])

export default __exports__